
(function(){
  /* ── GALLERY ─────────────────────────────────────────────── */
  var galleryTrack = document.querySelector('.gallery-track');
  var galleryThumbs = document.querySelectorAll('.gallery-thumb');
  var galleryTotal = galleryThumbs.length;
  var galleryIdx = 0;
  var galleryTouchX = null;

  function setGallery(i){
    galleryIdx = ((i % galleryTotal) + galleryTotal) % galleryTotal;
    if(galleryTrack) galleryTrack.style.transform = 'translateX(-'+galleryIdx*100+'%)';
    galleryThumbs.forEach(function(t,j){ t.classList.toggle('active', j===galleryIdx); });
  }
  document.querySelectorAll('.gallery-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ setGallery(galleryIdx + (btn.dataset.dir==='prev'?-1:1)); });
  });
  galleryThumbs.forEach(function(t,i){ t.addEventListener('click', function(){ setGallery(i); }); });
  var galleryWrap = document.querySelector('.gallery-wrap');
  if(galleryWrap){
    galleryWrap.addEventListener('touchstart',function(e){ galleryTouchX=e.touches[0].clientX; },{passive:true});
    galleryWrap.addEventListener('touchend',function(e){
      if(galleryTouchX===null)return;
      var diff=galleryTouchX-e.changedTouches[0].clientX;
      if(diff>40)setGallery(galleryIdx+1); else if(diff<-40)setGallery(galleryIdx-1);
      galleryTouchX=null;
    });
  }
  setGallery(0);

  /* ── BUNDLE SELECTOR ────────────────────────────────────────── */
  var bundleOpts = document.querySelectorAll('.bundle-option');
  var ctaBtn = document.getElementById('cta-btn');
  var selectedBundle = 1;

  function selectBundle(i){
    selectedBundle = i;
    bundleOpts.forEach(function(o,j){ o.classList.toggle('selected', j===i); });
  }
  bundleOpts.forEach(function(o,i){
    o.addEventListener('click', function(){ selectBundle(i); });
  });
  selectBundle(1);

  if(ctaBtn){
    ctaBtn.addEventListener('click', function(){
      var opt = bundleOpts[selectedBundle];
      var url = opt ? opt.dataset.url : null;
      var value = opt ? parseFloat(opt.dataset.price||0) : 0;
      var qty = opt ? parseInt(opt.dataset.qty||1) : 1;
      if(window.fbq){
        window.fbq('track','InitiateCheckout',{value:value,currency:'EUR',num_items:qty});
      }
      if(url) window.location.href = url;
    });
  }

  /* ── STICKY CTA ─────────────────────────────────────────────── */
  var stickyCta = document.getElementById('sticky-cta');
  var heroCta = document.getElementById('cta-btn');
  if(stickyCta && heroCta){
    window.addEventListener('scroll',function(){
      stickyCta.classList.toggle('visible', heroCta.getBoundingClientRect().bottom < 0);
    },{passive:true});
  }
  var stickyBtn = document.getElementById('sticky-cta-btn');
  if(stickyBtn){
    stickyBtn.addEventListener('click',function(){
      var sel = document.getElementById('bundle-selector');
      if(sel) sel.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }

  /* ── ACCORDIONS ─────────────────────────────────────────────── */
  document.querySelectorAll('.accordion-item').forEach(function(item){
    var trigger = item.querySelector('.accordion-trigger');
    if(trigger){
      trigger.addEventListener('click',function(){ item.classList.toggle('open'); });
    }
  });

  /* ── TESTIMONIAL CAROUSEL ───────────────────────────────────── */
  var tTrack = document.querySelector('.testimonials-track');
  var tCards = document.querySelectorAll('.testimonial-card');
  var tPrev = document.getElementById('t-prev');
  var tNext = document.getElementById('t-next');
  var tDotsContainer = document.getElementById('t-dots');
  var tIdx = 0;
  var tTouchX = null;
  var tVisible = 1;

  function tGetVisible(){
    if(window.innerWidth>=1024) return Math.min(3,tCards.length);
    if(window.innerWidth>=640)  return Math.min(2,tCards.length);
    return 1;
  }
  function tRender(){
    tVisible = tGetVisible();
    var maxIdx = Math.max(0, tCards.length - tVisible);
    if(tIdx > maxIdx) tIdx = maxIdx;
    var pct = 100 / tVisible;
    tCards.forEach(function(c){
      c.style.width = 'calc('+pct+'% - 12px)';
      c.style.margin = '0 6px';
    });
    if(tTrack) tTrack.style.transform = 'translateX(-'+(tIdx*(pct))+'%)';
    if(tPrev) tPrev.disabled = tIdx===0;
    if(tNext) tNext.disabled = tIdx>=maxIdx;
    if(tDotsContainer){
      tDotsContainer.innerHTML='';
      for(var i=0;i<=maxIdx;i++){
        var d=document.createElement('button');
        d.className='carousel-dot'+(i===tIdx?' active':'');
        (function(ii){d.addEventListener('click',function(){tIdx=ii;tRender();});})(i);
        tDotsContainer.appendChild(d);
      }
    }
  }
  if(tPrev) tPrev.addEventListener('click',function(){if(tIdx>0){tIdx--;tRender();}});
  if(tNext) tNext.addEventListener('click',function(){
    var maxIdx=Math.max(0,tCards.length-tVisible);
    if(tIdx<maxIdx){tIdx++;tRender();}
  });
  var tOuter = document.querySelector('.testimonials-track-outer');
  if(tOuter){
    tOuter.addEventListener('touchstart',function(e){tTouchX=e.touches[0].clientX;},{passive:true});
    tOuter.addEventListener('touchend',function(e){
      if(tTouchX===null)return;
      var diff=tTouchX-e.changedTouches[0].clientX;
      var maxIdx=Math.max(0,tCards.length-tVisible);
      if(diff>40&&tIdx<maxIdx){tIdx++;tRender();}
      else if(diff<-40&&tIdx>0){tIdx--;tRender();}
      tTouchX=null;
    });
  }
  window.addEventListener('resize',tRender);
  tRender();
})();
